<template>
    <v-container fluid class="fill-height m-auto">
        <v-row justify="center" align="center" >
            <v-col cols="12" class="py-0 text-center">
                <v-img
                    src="@/assets/logo.png"
                    contain
                    height="100"
                    width="auto"
                />
                <h2 class="mt-4">Select System</h2>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-card
                    class="system-card rounded-lg"
                    height="180"
                    width="400"
                    elevation="3"
                    @click="selectSystem('cardamom')"
                >
                    <v-img
                        src="@/assets/images (1).png"
                        contain
                        height="100"
                        width="auto"
                        class="mt-4"
                    />
                    <v-card-title class="d-flex justify-center py-2">
                        <span class="text-h6">Ugarit Cardamom System</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-card
                    class="system-card rounded-lg"
                    height="180"
                    @click="selectSystem('pepper')"
                    width="400"
                >
                    <v-img
                        src="@/assets/images.jpg"
                        contain
                        height="100"
                        width="auto"
                        class="mt-4"
                    />
                    <v-card-title class="d-flex justify-center py-2">
                        <span class="text-h6">Ugarit Pepper System</span>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    methods: {
        selectSystem (system) {
            if (system === 'cardamom') {
                // window.location.href = 'https://ugarit.beetronix.com'
                window.location.href = 'https://ugarit.mirta.net'
            } else if (system === 'pepper') {
                // window.location.href = 'https://ugarit-pepper.beetronix.com'
                window.location.href = 'https://ugarit-pepper.mirta.net'
            }
        }
    }
}
</script>
